import { v4 as uuidv4 } from 'uuid'

export const createVariation = variationConfig => ({
  id: uuidv4(),
  customAttributes: [],
  images: [],
  active: true,
  type: 'newProduct',
  package: {
    weight: {
      value: 0,
    },
    depth: 0,
    height: 0,
    width: 0,
  },
  prices: [
    {
      channel: 'magazineluiza',
      currency: 'BRL',
      price: 0,
      list_price: 0,
    },
  ],
  stocks: [
    {
      quantity: 0,
    },
  ],
  sku: '',
  ean: '',
  fulfillment: false,
  ...variationConfig,
})
